import React from 'react';
import PropTypes from 'prop-types';

import { 
  Button, 
  CircularProgress,
}                     from '@material-ui/core';

import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import TableFooter from '@material-ui/core/TableFooter';

export default function ExecutionDataTable(props) {
  
  const { 
    title, data, columns, columnOrder, loading,
    
    noHeader,
    noFooter,
    rowsPerPage,
    selectableRows, 

    onSelect, 
    onRowSelectionChange,
    onChangePrefs,
    
  } = props;
  
  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('EndTime');

  const muiTheme = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          size: "small"
        },
        paper: {
          boxShadow: "none",
        },
      },
    }
  });

  const handleViewColumnsChange = (changedColumn, action) => {
    if(onChangePrefs) {
      onChangePrefs({
        type: 'VIEW_COLUMNS',
        changedColumn,
        action
      });
    }
  };

  const handleColumnOrderChange = (newColumnOrder, columnIndex, newPosition) => {
    if(onChangePrefs) {
      onChangePrefs({
        type: 'COLUMN_ORDER',
        newColumnOrder,
        columnIndex,
        newPosition
      });
    }
  };

  const handleColumnSortChange = (changedColumn, direction) => {
    setOrder(direction);
    setOrderBy(changedColumn);
  };

  const handleCellClick = (colData, cellMeta) => {
    if(!columns[cellMeta.colIndex].clickable && onSelect) {
      onSelect(data[cellMeta.dataIndex]);
    }
  };

  const handleRowSelectionChange = (currentRowsSelected, allRowsSelected, rowsSelected) => {
    if(onRowSelectionChange) {
      onRowSelectionChange(allRowsSelected.map(r => data[r.dataIndex]));
    }
  };

  const executionSort = (data, colIndex, order) => {
    return data.sort((a, b) => { 
      if(columns[colIndex].name === 'EndTime') {
        if(!a.data[colIndex]) {
          return -1;
        } else if(!b.data[colIndex]) {
          return 1;
        }
      }
      return (a.data[colIndex] < b.data[colIndex] ? -1: 1 ) * (order === 'asc' ? 1 : -1);
    });
  };

  const options = {
    customFooter: noFooter?()=>{return(<TableFooter/>);}:null,
    customSort: executionSort,
    download: !noHeader,
    filter: !noHeader,
    viewColumns: !noHeader,
    columnOrder: columnOrder,
    draggableColumns: { enabled: true },
    enableNestedDataAccess: ".",
    expandableRows: false,
    expandableRowsHeader: false,
    print: false,
    rowsPerPage: rowsPerPage,

    onColumnSortChange: handleColumnSortChange,
    onColumnOrderChange: handleColumnOrderChange,
    onViewColumnsChange: handleViewColumnsChange,
    onCellClick: handleCellClick,
    onRowSelectionChange: onRowSelectionChange?handleRowSelectionChange:null,

    search: false,
    selectableRows: (onRowSelectionChange&&selectableRows==="none")?"single":selectableRows,
    selectableRowsOnClick: selectableRows!=='none',
    selectToolbarPlacement: 'none',
    sortOrder: {
      name: orderBy,
      direction: order
    },
    setTableProps: () => {
      return {
        padding: "default",
        size: "small",
      };
    },
    textLabels: {
      body: {
        noMatch: loading?"":"Sorry, no matching records found",
      },
    },
  };

  var displayTitle=null;
  
  if(loading) {
    displayTitle=<Button disabled size="small" style={{ width: '125px' }} startIcon={<CircularProgress size={20}/>}>Loading...</Button>;
  }

  if(React.isValidElement(title)) {
    displayTitle=<React.Fragment>{title}{displayTitle}</React.Fragment>;
  }
  
  return (
    <MuiThemeProvider theme={muiTheme}>
      <MUIDataTable
        title={displayTitle || title || ""}
        data={data}
        columns={columns}
        options={options}
      />
    </MuiThemeProvider>
  );
}

ExecutionDataTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  columnOrder: PropTypes.array,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  loading: PropTypes.bool,
  selectableRows: PropTypes.oneOf(['none', 'single', 'multiple']),
  noHeader: PropTypes.bool,
  noFooter: PropTypes.bool,
  rowsPerPage: PropTypes.number,
  onSelect: PropTypes.func,
  onRowSelectionChange: PropTypes.func,
  onChangePrefs: PropTypes.func,
};

ExecutionDataTable.defaultProps = {
  data: [],
  loading: false,
  rowsPerPage: 10,
  title: "Executions",
  noHeader: false,
  noFooter: false,
  selectableRows: "none",
};
